import { useState } from 'react';
import { deleteJobCharge } from '../api/jobCharges';

/**
 * Hook for deleting a job charge
 */
export function useDeleteJobCharge() {
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const deleteCharge = async (jobId: number, chargeId: number): Promise<boolean> => {
    setIsDeleting(true);
    setError(null);
    try {
      await deleteJobCharge(jobId, chargeId);
      return true;
    } catch (err) {
      const error = err as { response?: { data?: { message?: string } } };
      setError(error.response?.data?.message || 'Failed to delete job charge');
      return false;
    } finally {
      setIsDeleting(false);
    }
  };

  return {
    deleteCharge,
    isDeleting,
    error,
  };
}
